module.exports = __webpack_public_path__ + "media/images/area/area-9a93904e2bb385a86f96e3146e74c81c.jpg";